/* eslint-disable camelcase */
import React from "react"
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Button,
  List,
  ListItem,
  Avatar,
  TextField,
  CircularProgress,
  Paper, // <-- AQUÍ ESTÁ LA IMPORTACIÓN QUE FALTABA
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import DeleteIcon from "@mui/icons-material/Delete"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout"
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart"

const CarritoResumen = ({ open, onClose, carrito, setFormData, onCheckout, isSaving }) => {
  // ==========================================================================
  // FUNCIONES PARA ACTUALIZAR EL CARRITO DIRECTAMENTE DESDE EL PANEL
  // ==========================================================================
  const handleUpdateCantidad = (producto, nuevaCantidad) => {
    setFormData((prev) => {
      const nuevoDetalle = [...prev.detalle]
      const index = nuevoDetalle.findIndex(
        (item) => item.artcodigo === producto.artcodigo && item.invcodigo === producto.invcodigo,
      )

      if (index >= 0) {
        if (nuevaCantidad > 0) {
          nuevoDetalle[index].cantidad_solicitada = nuevaCantidad
        } else {
          // Si llega a 0, lo sacamos del carrito
          nuevoDetalle.splice(index, 1)
        }
      }
      return { ...prev, detalle: nuevoDetalle }
    })
  }

  const handleRemoveItem = (producto) => {
    handleUpdateCantidad(producto, 0)
  }

  // Cálculos para el resumen
  const totalUnidades = carrito.reduce((acc, item) => acc + (parseFloat(item.cantidad_solicitada) || 0), 0)
  const totalProductosUnicos = carrito.length

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: { xs: 320, sm: 400 }, display: "flex", flexDirection: "column", height: "100%" }}>
        {/* CABECERA DEL CARRITO */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "primary.main",
            color: "white",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Resumen de Solicitud
          </Typography>
          <IconButton color="inherit" onClick={onClose} disabled={isSaving}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* LISTA DE PRODUCTOS (CUERPO) */}
        <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2, bgcolor: "#f9f9f9" }}>
          {carrito.length === 0 ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="100%"
              color="text.secondary"
            >
              <RemoveShoppingCartIcon sx={{ fontSize: 60, mb: 2, opacity: 0.3 }} />
              <Typography variant="h6" align="center">
                Su carrito está vacío
              </Typography>
              <Typography variant="body2" align="center" mt={1}>
                Agregue productos desde el catálogo para generar su solicitud de ingreso.
              </Typography>
            </Box>
          ) : (
            <List disablePadding>
              {carrito.map((item) => (
                <Paper
                  key={`${item.invcodigo}-${item.artcodigo}`}
                  elevation={1}
                  sx={{ mb: 2, p: 1.5, borderRadius: 2 }}
                >
                  <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                    {/* Imagen del producto */}
                    <Avatar
                      variant="rounded"
                      src={item.imagen_b64 ? `data:image/jpeg;base64,${item.imagen_b64}` : ""}
                      sx={{ width: 60, height: 60, mr: 2, bgcolor: "transparent", border: "1px solid #eee" }}
                    />

                    {/* Detalles del producto */}
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="caption" color="text.secondary" fontWeight="bold">
                        Cód: {item.artcodigo}
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: "bold", lineHeight: 1.2, mb: 1 }}>
                        {item.artdescri}
                      </Typography>

                      {/* Controles de Cantidad miniatura */}
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Box display="flex" alignItems="center" bgcolor="#f5f7fa" borderRadius={1}>
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleUpdateCantidad(item, item.cantidad_solicitada - 1)}
                          >
                            <RemoveIcon fontSize="small" />
                          </IconButton>
                          <TextField
                            variant="standard"
                            value={item.cantidad_solicitada}
                            onChange={(e) => {
                              const val = parseInt(e.target.value, 10)
                              handleUpdateCantidad(item, isNaN(val) ? 0 : val)
                            }}
                            inputProps={{
                              style: { textAlign: "center", width: "40px", fontSize: "0.875rem", fontWeight: "bold" },
                            }}
                            InputProps={{ disableUnderline: true }}
                          />
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleUpdateCantidad(item, item.cantidad_solicitada + 1)}
                          >
                            <AddIcon fontSize="small" />
                          </IconButton>
                        </Box>

                        <IconButton size="small" color="error" onClick={() => handleRemoveItem(item)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </ListItem>
                </Paper>
              ))}
            </List>
          )}
        </Box>

        {/* PIE DEL CARRITO (CHECKOUT) */}
        <Box
          sx={{ p: 2, bgcolor: "white", borderTop: "1px solid #e0e0e0", boxShadow: "0px -4px 10px rgba(0,0,0,0.05)" }}
        >
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body2" color="text.secondary">
              Total Productos:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {totalProductosUnicos}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography variant="body2" color="text.secondary">
              Total Unidades:
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {totalUnidades}
            </Typography>
          </Box>

          <Button
            variant="contained"
            color="secondary"
            fullWidth
            size="large"
            disabled={carrito.length === 0 || isSaving}
            startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <ShoppingCartCheckoutIcon />}
            onClick={onCheckout}
            sx={{ fontWeight: "bold", borderRadius: 2, py: 1.5 }}
          >
            {isSaving ? "Procesando..." : "Confirmar Solicitud"}
          </Button>
        </Box>
      </Box>
    </Drawer>
  )
}

export default CarritoResumen
